import React, { Suspense, lazy, useState } from 'react';

const UnservedTab = lazy(() => import('./ManagerTabs/UnservedTab'));
const CheckedInTab = lazy(() => import('./ManagerTabs/CheckedInTab'));
const HistoryTab = lazy(() => import('./ManagerTabs/HistoryTab'));
const CalendarTab = lazy(() => import('./ManagerTabs/CalendarTab'));

const tabList = [
  { key: 'calendar', label: 'Calendar', component: CalendarTab },
  { key: 'unserved', label: 'Unserved', component: UnservedTab },
  { key: 'checkedin', label: 'Checked-in', component: CheckedInTab },
  { key: 'history', label: 'History', component: HistoryTab },
];

const Manager = () => {
  const [activeTab, setActiveTab] = useState('calendar');
  const ActiveComponent = tabList.find(tab => tab.key === activeTab).component;

  return (
    <div className="manager-container">
      <h2>Reservation Manager</h2>
      <div className="manager-tabs">
        {tabList.map(tab => (
          <button
            key={tab.key}
            className={`manager-tab-btn${activeTab === tab.key ? ' active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="manager-tab-content">
        <Suspense fallback={<div>Loading...</div>}>
          <ActiveComponent />
        </Suspense>
      </div>
    </div>
  );
};

export default Manager;